<template>
    <SavedChangesMessage :visible="isSaved" />
</template>
<script lang="ts" setup>
import { SavedChangesMessage } from '..';
import { onMounted, ref, watch } from 'vue';

const isSaved = ref(false);

watch(
    () => isSaved.value,
    (newVal) => {
        if (newVal) {
            setTimeout(() => {
                isSaved.value = false;
            }, 3000);
        }
    },
);

onMounted(() => {
    isSaved.value = true;
});
</script>
